import { render, staticRenderFns } from "./ActionBackBrowser.vue?vue&type=template&id=36c73e69&"
import script from "./ActionBackBrowser.vue?vue&type=script&lang=js&"
export * from "./ActionBackBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports